import React, { useState, useEffect, useRef } from 'react';
import { DotIcon } from '../icons';
import { DropdownWrapper, FilterDropdownButton, FilterOptionsList, FilterOptionItem } from '../calendar.styles';

function FilterDropdown({ value, onChange, options, placeholder }) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    document.addEventListener('scroll', handler, true);
    const onWheel = (e) => {
      const t = e.target;
      if (t && t.tagName === 'INPUT' && t.type === 'number' && wrapperRef.current && wrapperRef.current.contains(t)) {
        e.preventDefault();
      }
    };
    document.addEventListener('wheel', onWheel, { passive: false, capture: true });
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('scroll', handler, true);
      document.removeEventListener('wheel', onWheel, { capture: true });
    };
  }, [open]);

  const selected = options.find(o => o.value === value) || options[0];

  return (
    <div>
      <DropdownWrapper ref={wrapperRef}>
        <FilterDropdownButton type="button" data-open={open} aria-haspopup="listbox" aria-expanded={open} onClick={() => setOpen(o => !o)}>
          <span style={{flex:1, textAlign: 'left'}}>{selected ? selected.label : placeholder}</span>
          {open ? (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M18 15l-6-6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          ) : (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          )}
        </FilterDropdownButton>

        {open && (
          <FilterOptionsList role="listbox">
            {options.map(o => {
              const sel = o.value === value;
              return (
                <FilterOptionItem key={o.value} data-selected={sel} onClick={() => { onChange(o.value); setOpen(false); }}>
                  {sel && <DotIcon />}
                  <span>{o.label}</span>
                </FilterOptionItem>
              );
            })}
          </FilterOptionsList>
        )}
      </DropdownWrapper>
    </div>
  );
}

export default FilterDropdown;
